var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Backdrop, Box, Chip, CircularProgress, Collapse, Divider, Drawer, FormHelperText, Grid, IconButton, TextField, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { GridAddIcon, GridRemoveIcon } from '@mui/x-data-grid-premium';
import { t } from 'i18next';
import { debounce } from '@mui/material';
;
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPriceWithTaxUrl, getTaxUrl, getValidateQuantityAndGetTaxesUrl } from '../../../../api/url';
import { ChevronDownIcon, ChevronUpIcon } from '../../../../assets/customIcons';
import { FormSearchSelect } from '../../../../builderPackage/components/dynamicFormBuilder/components/formSearchSelect';
import { InputBox, MuiButton, MuiStack } from '../../../../components';
import { MuiCheckBox } from '../../../../components/atoms/checkBox';
import DrawerHeader from '../../../../components/atoms/DrawerHeader';
import { MuiIconButton } from '../../../../components/atoms/iconButtonComponent';
import { MuiSelectComponent } from '../../../../components/atoms/muiSelectComponent';
import Loader from '../../../../components/molecules/loader';
import { EJobItemType, LOCAL_STORAGE_KEYS } from '../../../../constants';
import { showLoader } from '../../../../redux/commonSlice';
import { getListAPI } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { getLocalStorageItem } from '../../../../utils/storageHelper';
import { REG } from '../../../../utils/validationHelper';
import { CrossIcon } from '../../../fieldFailureReports/assets/svg';
import { getServiceTypeList, UnitOfMeasurementList } from '../../../jobCardDetails/services/apiCalls';
import { getInstallbaseDetailsAPICall } from '../../../jobCardDetails/services/utils';
var regex = REG.validateDecimalAndNonNumeric;
var PartLabourDetailsDrawer = function (props) {
    var _jobItemDetails$Price, _jobItemDetails$Selec, _jobItemDetails$Price2, _selectedPriceDetails, _documentDetailsGetBy3, _drawerItem$jobType, _drawerItem$jobType2, _drawerItem$jobType3, _drawerItem$jobType4, _drawerItem$Price, _selectedPriceDetails2, _selectedPriceDetails3;
    var dispatch = useAppDispatch();
    var open = props.open, onClose = props.onClose, jobItemDetails = props.jobItemDetails, SystemName = props.SystemName, isDisabled = props.isDisabled, jobItemType = props.jobItemType, setHasUnsavedChanges = props.setHasUnsavedChanges;
    var _a = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _a.ModuleDetailsGetById, documentDetailsGetById = _a.documentDetailsGetById, installbaseDetailsById = _a.installbaseDetailsById, UOMList = _a.UOMList;
    var documentDetails = ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? ModuleDetailsGetById : documentDetailsGetById;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var isLoaderOpen = useAppSelector(function (state) { return state.common.isLoader; }).isLoaderOpen;
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _b = useState(false), openTaxes = _b[0], setOpenTaxes = _b[1];
    var _c = useState(false), openSummary = _c[0], setOpenSummary = _c[1];
    var _d = useState(jobItemDetails), drawerItem = _d[0], setDrawerItem = _d[1];
    var _e = useState(jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Price = jobItemDetails.Price) === null || _jobItemDetails$Price === void 0 ? void 0 : _jobItemDetails$Price[0]), selectedPriceDetails = _e[0], setSelectedPriceDetails = _e[1];
    var _f = useState(Number(jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.Quantity) || 0), originalQuantity = _f[0], setOriginalQuantity = _f[1];
    var _g = useState(Number((jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Selec = jobItemDetails.SelectedPriceDetails) === null || _jobItemDetails$Selec === void 0 ? void 0 : _jobItemDetails$Selec.Rate) || (jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Price2 = jobItemDetails.Price) === null || _jobItemDetails$Price2 === void 0 || (_jobItemDetails$Price2 = _jobItemDetails$Price2[0]) === null || _jobItemDetails$Price2 === void 0 ? void 0 : _jobItemDetails$Price2.Rate)) || 0), originalRate = _g[0], setOriginalRate = _g[1];
    var _h = useState(false), hasChanges = _h[0], setHasChanges = _h[1];
    var _j = useState((jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.jobType) || ''), jobType = _j[0], setJobType = _j[1];
    var totalTax = (selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails = selectedPriceDetails.Taxes) === null || _selectedPriceDetails === void 0 ? void 0 : _selectedPriceDetails.reduce(function (accaccumulator, currentObj) { return Number(accaccumulator) + Number(currentObj.TaxComponentAmount); }, 0).toFixed(2)) || 0;
    useEffect(function () {
        var _documentDetailsGetBy, _documentDetailsGetBy2;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy = documentDetailsGetById.data) !== null && _documentDetailsGetBy !== void 0 && _documentDetailsGetBy.InstallBaseId)
            getInstallbaseDetailsAPICall(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.InstallBaseId);
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.InstallBaseId]);
    useEffect(function () {
        if (jobItemDetails) {
            var _jobItemDetails$Selec3, _jobItemDetails$Price5;
            var tempJobItemDetails = _objectSpread({}, jobItemDetails);
            tempJobItemDetails.OriginalQuantity = jobItemDetails.Quantity;
            setDrawerItem(tempJobItemDetails);
            if (jobItemDetails.SelectedPriceDetails) {
                var _jobItemDetails$Selec2;
                var tempSelectedPrice = _objectSpread(_objectSpread({}, jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.SelectedPriceDetails), {}, {
                    OriginalRate: jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Selec2 = jobItemDetails.SelectedPriceDetails) === null || _jobItemDetails$Selec2 === void 0 ? void 0 : _jobItemDetails$Selec2.Rate
                });
                setSelectedPriceDetails(tempSelectedPrice);
            }
            else {
                var _jobItemDetails$Price3, _jobItemDetails$Price4;
                var tempSelectedPrice = _objectSpread(_objectSpread({}, jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Price3 = jobItemDetails.Price) === null || _jobItemDetails$Price3 === void 0 ? void 0 : _jobItemDetails$Price3[0]), {}, {
                    OriginalRate: jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Price4 = jobItemDetails.Price) === null || _jobItemDetails$Price4 === void 0 || (_jobItemDetails$Price4 = _jobItemDetails$Price4[0]) === null || _jobItemDetails$Price4 === void 0 ? void 0 : _jobItemDetails$Price4.Rate
                });
                setSelectedPriceDetails(tempSelectedPrice);
            }
            // Set original quantity for change detection - ensure it's a number
            var qty = jobItemDetails.Quantity ? Number(jobItemDetails.Quantity) : 0;
            var rate = (_jobItemDetails$Selec3 = jobItemDetails.SelectedPriceDetails) !== null && _jobItemDetails$Selec3 !== void 0 && _jobItemDetails$Selec3.Rate ? Number(jobItemDetails.SelectedPriceDetails.Rate) : jobItemDetails !== null && jobItemDetails !== void 0 && (_jobItemDetails$Price5 = jobItemDetails.Price) !== null && _jobItemDetails$Price5 !== void 0 && (_jobItemDetails$Price5 = _jobItemDetails$Price5[0]) !== null && _jobItemDetails$Price5 !== void 0 && _jobItemDetails$Price5.Rate ? Number(jobItemDetails.Price[0].Rate) : 0;
            setOriginalQuantity(qty);
            setOriginalRate(rate);
            setJobType(jobItemDetails.jobType || '');
            setHasChanges(false);
        }
    }, [jobItemDetails]);
    // Check for changes whenever quantity or rate changes
    useEffect(function () {
        // Add null checks to prevent errors
        if (!drawerItem || !selectedPriceDetails)
            return;
        var currentQuantity = Number(drawerItem.Quantity) || 0;
        var originalQty = Number(originalQuantity) || 0;
        var currentRate = Number(selectedPriceDetails.Rate) || 0;
        var originalRt = Number(originalRate) || 0;
        // Use small tolerance for decimal comparison to handle floating-point precision
        var tolerance = 0.0001;
        var hasQuantityChanged = Math.abs(currentQuantity - originalQty) > tolerance;
        var hasRateChanged = Math.abs(currentRate - originalRt) > tolerance;
        // For Parts: only check quantity changes
        // For Labour: only check rate changes (quantity cannot be changed for labour)
        if (jobType === "Labour") {
            setHasChanges(hasRateChanged);
        }
        else {
            setHasChanges(hasQuantityChanged);
        }
    }, [drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Quantity, originalQuantity, selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.Rate, originalRate, jobType]);
    var handleServiceType = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target, _event$target2, _event$target$value, _event$target3, PricesBasedOnServiceType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getPriceDetailsWithTax(event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value, drawerItem.UnitOfMeasurementId)];
                case 1:
                    PricesBasedOnServiceType = _a.sent();
                    setDrawerItem(_objectSpread(_objectSpread({}, drawerItem), {}, {
                        ServiceTypeId: (_event$target$value = event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value) !== null && _event$target$value !== void 0 ? _event$target$value : "",
                        Price: PricesBasedOnServiceType
                    }));
                    if ((PricesBasedOnServiceType === null || PricesBasedOnServiceType === void 0 ? void 0 : PricesBasedOnServiceType.length) > 0) {
                        setSelectedPriceDetails(PricesBasedOnServiceType[0]);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeUOM = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target4, _event$target5, _event$target$value2, _event$target6, PricesBasedOnServiceType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event !== null && event !== void 0 && (_event$target4 = event.target) !== null && _event$target4 !== void 0 && _event$target4.value)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getPriceDetailsWithTax(drawerItem.ServiceTypeId, event === null || event === void 0 || (_event$target5 = event.target) === null || _event$target5 === void 0 ? void 0 : _event$target5.value)];
                case 1:
                    PricesBasedOnServiceType = _a.sent();
                    setDrawerItem(_objectSpread(_objectSpread({}, drawerItem), {}, {
                        UnitOfMeasurementId: (_event$target$value2 = event === null || event === void 0 || (_event$target6 = event.target) === null || _event$target6 === void 0 ? void 0 : _event$target6.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "",
                        Price: PricesBasedOnServiceType
                    }));
                    if ((PricesBasedOnServiceType === null || PricesBasedOnServiceType === void 0 ? void 0 : PricesBasedOnServiceType.length) > 0) {
                        setSelectedPriceDetails(PricesBasedOnServiceType[0]);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    setDrawerItem(_objectSpread(_objectSpread({}, drawerItem), {}, {
                        UnitOfMeasurementId: ""
                    }));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChangePrice = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedMRP, selectedPrice;
        return __generator(this, function (_a) {
            selectedMRP = event.target.value;
            selectedPrice = drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Price.find(function (item) { return item.MRP === selectedMRP; });
            if (selectedPrice) {
                setSelectedPriceDetails(selectedPrice);
            }
            return [2 /*return*/];
        });
    }); };
    var handleInputRateChange = function (event, item) {
        var value = event.target.value.trim().replace(/^0+(?=\d)/, '');
        if (!regex.test(value) && value !== '')
            return;
        if (drawerItem.EditableRange === 0) {
            if ((drawerItem.MinLimit == null || value >= drawerItem.MinLimit) && (drawerItem.MaxLimit == null || value <= drawerItem.MaxLimit) || value === '') {
                setSelectedPriceDetails(function (prevDetails) { return _objectSpread(_objectSpread({}, prevDetails), {}, {
                    Rate: event.target.value
                }); });
                setDrawerItem(function (prevValues) { return _objectSpread(_objectSpread({}, prevValues), {}, {
                    rateError: false,
                    rateErrorMessage: ''
                }); });
            }
            else {
                setSelectedPriceDetails(function (prevDetails) { return _objectSpread(_objectSpread({}, prevDetails), {}, {
                    Rate: event.target.value
                }); });
                setDrawerItem(function (prevValues) {
                    return _objectSpread(_objectSpread({}, prevValues), {}, {
                        rateError: true,
                        rateErrorMessage: drawerItem.MinLimit != null && drawerItem.MaxLimit != null ? "Rate should be between \u20B9".concat(Number(drawerItem.MinLimit).toFixed(2), " and \u20B9").concat(Number(drawerItem.MaxLimit).toFixed(2)) : drawerItem.MinLimit != null ? "Min limit \u20B9".concat(Number(drawerItem.MinLimit).toFixed(2)) : "Max limit \u20B9".concat(Number(drawerItem.MaxLimit).toFixed(2))
                    });
                });
            }
        }
        else if (drawerItem.EditableRange === 1) {
            setSelectedPriceDetails(function (prevDetails) { return _objectSpread(_objectSpread({}, prevDetails), {}, {
                Rate: value
            }); });
            if (value < drawerItem.MinLimit) {
                setDrawerItem(function (prevValues) {
                    return _objectSpread(_objectSpread({}, prevValues), {}, {
                        rateError: true,
                        rateErrorMessage: "Min limit \u20B9".concat(Number(drawerItem.MinLimit).toFixed(2))
                    });
                });
            }
            else {
                setDrawerItem(function (prevValues) {
                    return _objectSpread(_objectSpread({}, prevValues), {}, {
                        rateError: false,
                        rateErrorMessage: ""
                    });
                });
            }
        }
        else if (drawerItem.EditableRange === 2) {
            if (value >= drawerItem.MinLimit || value === '') {
                setSelectedPriceDetails(function (prevDetails) { return _objectSpread(_objectSpread({}, prevDetails), {}, {
                    Rate: value
                }); });
                if (value > drawerItem.MaxLimit) {
                    setDrawerItem(function (prevValues) {
                        return _objectSpread(_objectSpread({}, prevValues), {}, {
                            rateError: true,
                            rateErrorMessage: "Max limit \u20B9".concat(Number(drawerItem.MaxLimit).toFixed(2))
                        });
                    });
                }
                else {
                    setDrawerItem(function (prevValues) {
                        return _objectSpread(_objectSpread({}, prevValues), {}, {
                            rateError: false,
                            rateErrorMessage: ""
                        });
                    });
                }
            }
        }
    };
    var handleTaxesBasedOnRateChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value, TaxesBasedOnRate, _TaxesBasedOnRate$dat, _TaxesBasedOnRate$dat2, _TaxesBasedOnRate$dat3, _TaxesBasedOnRate$dat4, _TaxesBasedOnRate$dat5, _TaxesBasedOnRate$dat6, _TaxesBasedOnRate$dat7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (event.target.value === '') {
                        setDrawerItem(function (prevValues) {
                            return _objectSpread(_objectSpread({}, prevValues), {}, {
                                rateError: true,
                                rateErrorMessage: 'Rate is required'
                            });
                        });
                        return [2 /*return*/];
                    }
                    if (Number(event.target.value) <= 0) {
                        setDrawerItem(function (prevValues) {
                            return _objectSpread(_objectSpread({}, prevValues), {}, {
                                rateError: true,
                                rateErrorMessage: 'Rate must be greater than 0'
                            });
                        });
                        return [2 /*return*/];
                    }
                    value = Number(event.target.value);
                    if (drawerItem.EditableRange === 0) {
                        if ((drawerItem.MinLimit == null || value >= drawerItem.MinLimit) && (drawerItem.MaxLimit == null || value <= drawerItem.MaxLimit)) {
                            setDrawerItem(function (prevValues) { return _objectSpread(_objectSpread({}, prevValues), {}, {
                                rateError: false,
                                rateErrorMessage: ''
                            }); });
                        }
                        else {
                            setDrawerItem(function (prevValues) {
                                return _objectSpread(_objectSpread({}, prevValues), {}, {
                                    rateError: true,
                                    rateErrorMessage: drawerItem.MinLimit != null && drawerItem.MaxLimit != null ? "Rate should be between \u20B9".concat(Number(drawerItem.MinLimit).toFixed(2), " and \u20B9").concat(Number(drawerItem.MaxLimit).toFixed(2)) : drawerItem.MinLimit != null ? "Min limit \u20B9".concat(Number(drawerItem.MinLimit).toFixed(2)) : "Max limit \u20B9".concat(Number(drawerItem.MaxLimit).toFixed(2))
                                });
                            });
                            return [2 /*return*/];
                        }
                    }
                    else if (drawerItem.EditableRange === 1) {
                        if (value < drawerItem.MinLimit) {
                            setDrawerItem(function (prevValues) {
                                return _objectSpread(_objectSpread({}, prevValues), {}, {
                                    rateError: true,
                                    rateErrorMessage: "Min limit \u20B9".concat(Number(drawerItem.MinLimit).toFixed(2))
                                });
                            });
                            return [2 /*return*/];
                        }
                        else {
                            setDrawerItem(function (prevValues) {
                                return _objectSpread(_objectSpread({}, prevValues), {}, {
                                    rateError: false,
                                    rateErrorMessage: ""
                                });
                            });
                        }
                    }
                    else if (drawerItem.EditableRange === 2) {
                        if (value > drawerItem.MaxLimit) {
                            setDrawerItem(function (prevValues) {
                                return _objectSpread(_objectSpread({}, prevValues), {}, {
                                    rateError: true,
                                    rateErrorMessage: "Max limit \u20B9".concat(Number(drawerItem.MaxLimit).toFixed(2))
                                });
                            });
                            return [2 /*return*/];
                        }
                        else {
                            setDrawerItem(function (prevValues) {
                                return _objectSpread(_objectSpread({}, prevValues), {}, {
                                    rateError: false,
                                    rateErrorMessage: ""
                                });
                            });
                        }
                    }
                    return [4 /*yield*/, getTax(Number(drawerItem.Quantity), Number(event.target.value))];
                case 1:
                    TaxesBasedOnRate = _a.sent();
                    if (TaxesBasedOnRate.success && TaxesBasedOnRate !== null && TaxesBasedOnRate !== void 0 && TaxesBasedOnRate.data) {
                        setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Amount: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat === void 0 ? void 0 : _TaxesBasedOnRate$dat.Amount,
                            MRP: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat2 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat2 === void 0 ? void 0 : _TaxesBasedOnRate$dat2.MRP,
                            Rate: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat3 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat3 === void 0 ? void 0 : _TaxesBasedOnRate$dat3.Rate,
                            OriginalRate: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat4 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat4 === void 0 ? void 0 : _TaxesBasedOnRate$dat4.Rate,
                            TaxableAmount: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat5 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat5 === void 0 ? void 0 : _TaxesBasedOnRate$dat5.TaxableAmount,
                            Taxes: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat6 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat6 === void 0 ? void 0 : _TaxesBasedOnRate$dat6.Taxes,
                            BaseAmount: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat7 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat7 === void 0 ? void 0 : _TaxesBasedOnRate$dat7.BaseAmount
                        }));
                        setDrawerItem(_objectSpread(_objectSpread({}, drawerItem), {}, {
                            IsPriceUpdateUI: true,
                            rateError: false,
                            rateErrorMessage: ''
                        }));
                    }
                    else {
                        setSelectedPriceDetails(function (preValues) {
                            return _objectSpread(_objectSpread({}, preValues), {}, {
                                Rate: preValues.OriginalRate
                            });
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        var tempPrevDetails = _objectSpread({}, selectedPriceDetails);
        if (drawerItem.rateError || !tempPrevDetails.Rate) {
            tempPrevDetails.Rate = tempPrevDetails.OriginalRate;
        }
        onClose(_objectSpread(_objectSpread({}, drawerItem), {}, {
            rateError: false,
            rateErrorMessage: '',
            error: false,
            errorMessage: "",
            Quantity: drawerItem.OriginalQuantity,
            SelectedPriceDetails: tempPrevDetails,
            changeDetected: hasChanges
        }));
        setOpenSummary(false);
        setOpenTaxes(false);
    };
    var handleQuantityChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target7, value, updatedItem, DecimalPrecision, validationRules;
        return __generator(this, function (_a) {
            value = event === null || event === void 0 || (_event$target7 = event.target) === null || _event$target7 === void 0 ? void 0 : _event$target7.value;
            updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                error: false,
                errorMessage: ""
            });
            if (!value) {
                updatedItem.Quantity = "";
                setDrawerItem(updatedItem);
                return [2 /*return*/];
            }
            if (!/^\d*\.?\d*$/.test(value)) {
                updatedItem.error = true;
                updatedItem.errorMessage = "Invalid input format";
                setDrawerItem(updatedItem);
                return [2 /*return*/];
            }
            if (!(+value > 0)) {
                updatedItem.error = true;
                updatedItem.errorMessage = "Quantity should be greater than 0";
            }
            else {
                DecimalPrecision = drawerItem.DecimalPrecision;
                validationRules = {
                    0: REG.validateInteger,
                    1: REG.validateDecimalUptoOneDigit,
                    2: REG.validateDecimalAndNonNumeric
                };
                if (DecimalPrecision !== undefined && validationRules[DecimalPrecision]) {
                    if (!validationRules[DecimalPrecision].test(value)) {
                        updatedItem.error = true;
                        updatedItem.errorMessage = DecimalPrecision === 0 ? "Enter Qty in multiple of 1" : "Up to ".concat(DecimalPrecision, " decimal precision is allowed");
                    }
                    else {
                        updatedItem.Quantity = value;
                    }
                }
            }
            setDrawerItem(updatedItem);
            return [2 /*return*/];
        });
    }); };
    var handleOnBlurQuantityChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedItem, newQuantity_1, TaxesBasedOnQuantity, _a, Amount_1, MRP_1, Rate_1, TaxableAmount_1, Taxes_1, BaseAmount_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updatedItem = _objectSpread({}, drawerItem);
                    if (!drawerItem.Quantity) {
                        setDrawerItem(function (prev) {
                            return _objectSpread(_objectSpread({}, prev), {}, {
                                error: true,
                                errorMessage: 'Quantity should be greater than 0'
                            });
                        });
                        return [2 /*return*/];
                    }
                    if (Number(drawerItem.Quantity) > 999999.99) {
                        setDrawerItem(function (prev) {
                            return _objectSpread(_objectSpread({}, prev), {}, {
                                error: true,
                                errorMessage: 'Quantity cannot be greater than 999999.99'
                            });
                        });
                        return [2 /*return*/];
                    }
                    if (!!updatedItem.error) return [3 /*break*/, 2];
                    newQuantity_1 = Number(Number(drawerItem.Quantity).toFixed(2));
                    return [4 /*yield*/, validateAndGetTax(newQuantity_1, selectedPriceDetails.Rate)];
                case 1:
                    TaxesBasedOnQuantity = _b.sent();
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        _a = TaxesBasedOnQuantity.data, Amount_1 = _a.Amount, MRP_1 = _a.MRP, Rate_1 = _a.Rate, TaxableAmount_1 = _a.TaxableAmount, Taxes_1 = _a.Taxes, BaseAmount_1 = _a.BaseAmount;
                        setSelectedPriceDetails(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                            Amount: Amount_1,
                            MRP: MRP_1,
                            Rate: Rate_1,
                            TaxableAmount: TaxableAmount_1,
                            Taxes: Taxes_1,
                            BaseAmount: BaseAmount_1,
                            OriginalRate: Rate_1
                        }); });
                        setDrawerItem(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                            OriginalQuantity: newQuantity_1
                        }); });
                    }
                    else {
                        setDrawerItem(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                            Quantity: prev.OriginalQuantity
                        }); });
                    }
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var debouncedTaxCalculation = useCallback(debounce(function (updatedQuantity, rate) { return __awaiter(void 0, void 0, void 0, function () {
        var TaxesBasedOnQuantity, _a, Amount_2, MRP_2, Rate_2, TaxableAmount_2, Taxes_2, BaseAmount_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, validateAndGetTax(updatedQuantity, rate)];
                case 1:
                    TaxesBasedOnQuantity = _b.sent();
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        _a = TaxesBasedOnQuantity.data, Amount_2 = _a.Amount, MRP_2 = _a.MRP, Rate_2 = _a.Rate, TaxableAmount_2 = _a.TaxableAmount, Taxes_2 = _a.Taxes, BaseAmount_2 = _a.BaseAmount;
                        setSelectedPriceDetails(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                            Amount: Amount_2,
                            MRP: MRP_2,
                            Rate: Rate_2,
                            TaxableAmount: TaxableAmount_2,
                            Taxes: Taxes_2,
                            BaseAmount: BaseAmount_2,
                            OriginalRate: Rate_2
                        }); });
                        setDrawerItem(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                            OriginalQuantity: updatedQuantity
                        }); });
                    }
                    else {
                        setSelectedPriceDetails(function (prev) {
                            return _objectSpread(_objectSpread({}, prev), {}, {
                                Rate: prev.OriginalRate
                            });
                        });
                        setDrawerItem(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                            Quantity: prev.OriginalQuantity
                        }); });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, 500), [selectedPriceDetails, drawerItem]);
    var handleQuantityDecrement = function () {
        if (Number((Number(drawerItem.Quantity) - 1).toFixed(2)) > 999999.99) {
            var updatedDrawerItem = _objectSpread({}, drawerItem);
            updatedDrawerItem.Quantity = Number((Number(drawerItem.Quantity) - 1).toFixed(2));
            updatedDrawerItem.error = true;
            updatedDrawerItem.errorMessage = 'Quantity cannot be greater than 999999.99';
            setDrawerItem(updatedDrawerItem);
        }
        else {
            setDrawerItem(function (prev) {
                var newQuantity = Number((Number(prev.Quantity) - 1).toFixed(2));
                if (newQuantity < 1)
                    return prev;
                debouncedTaxCalculation(newQuantity, selectedPriceDetails.Rate);
                return _objectSpread(_objectSpread({}, prev), {}, {
                    Quantity: newQuantity,
                    error: false,
                    errorMessage: ''
                });
            });
        }
    };
    var handleQuantityIncrement = function () {
        if (Number((Number(drawerItem.Quantity) + 1).toFixed(2)) > 999999.99) {
            var updatedDrawerItem = _objectSpread({}, drawerItem);
            updatedDrawerItem.Quantity = Number((Number(drawerItem.Quantity) + 1).toFixed(2));
            updatedDrawerItem.error = true;
            updatedDrawerItem.errorMessage = 'Quantity cannot be greater than 999999.99';
            setDrawerItem(updatedDrawerItem);
        }
        else {
            setDrawerItem(function (prev) {
                var newQuantity = Number((Number(prev.Quantity) + 1).toFixed(2));
                debouncedTaxCalculation(newQuantity, selectedPriceDetails.Rate);
                return _objectSpread(_objectSpread({}, prev), {}, {
                    error: false,
                    errorMessage: '',
                    Quantity: newQuantity
                });
            });
        }
    };
    var getPriceDetailsWithTax = function (ServiceTypeId, UOMId) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetails$data, _documentDetails$data2, _documentDetails$data3, _documentDetails$data4, _Response$payload, _Response$payload2, _Response$payload3, requestBody, Response, _Response$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "SystemName": (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Part" ? "Parts" : "Service",
                        "ItemId": drawerItem.ChildId,
                        "OrganizationId": storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId,
                        "VinNo": documentDetails === null || documentDetails === void 0 || (_documentDetails$data = documentDetails.data) === null || _documentDetails$data === void 0 ? void 0 : _documentDetails$data.VinNo,
                        "PreJobCardDocumentId": documentDetails === null || documentDetails === void 0 || (_documentDetails$data2 = documentDetails.data) === null || _documentDetails$data2 === void 0 ? void 0 : _documentDetails$data2.id,
                        "Quantity": Number(drawerItem.Quantity),
                        "Entity": SystemName,
                        "UnitOfMeasurementId": UOMId,
                        "ServiceTypeId": ServiceTypeId,
                        OrganizationStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data3 = documentDetails.data) === null || _documentDetails$data3 === void 0 ? void 0 : _documentDetails$data3.OrganizationStateCode,
                        CustomerStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data4 = documentDetails.data) === null || _documentDetails$data4 === void 0 ? void 0 : _documentDetails$data4.CustomerStateCode,
                        HSNSACCode: selectedPriceDetails.HSNSACCode,
                        CDMSHSNSACCode: selectedPriceDetails.CDMSHSNSACCode
                    };
                    // if (drawerItem.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem.HSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem.SACCode
                    // }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // if (drawerItem.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem.HSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem.SACCode
                    // }
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getPriceWithTaxUrl,
                            request: requestBody
                        }))];
                case 2:
                    Response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.success && Response !== null && Response !== void 0 && (_Response$payload2 = Response.payload) !== null && _Response$payload2 !== void 0 && (_Response$payload2 = _Response$payload2.value) !== null && _Response$payload2 !== void 0 && _Response$payload2.data && (Response === null || Response === void 0 || (_Response$payload3 = Response.payload) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.value) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.data) === null || _Response$payload3 === void 0 ? void 0 : _Response$payload3.length) > 0) {
                        return [2 /*return*/, Response === null || Response === void 0 || (_Response$payload4 = Response.payload) === null || _Response$payload4 === void 0 || (_Response$payload4 = _Response$payload4.value) === null || _Response$payload4 === void 0 ? void 0 : _Response$payload4.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getTax = function (Qty, Rate) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetails$data5, _documentDetails$data6, _documentDetails$data7, _Response$payload5, _Response$payload6, requestBody, Response, _Response$payload7, data, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        Quantity: Qty,
                        "Rate": Rate,
                        DocumentDate: documentDetails === null || documentDetails === void 0 || (_documentDetails$data5 = documentDetails.data) === null || _documentDetails$data5 === void 0 ? void 0 : _documentDetails$data5.CreatedOn,
                        "Entity": SystemName,
                        "ServiceTypeId": drawerItem.ServiceTypeId,
                        "UnitOfMeasurementId": drawerItem.UnitOfMeasurementId,
                        "PriceMethod": selectedPriceDetails.PriceGroupCategoryKey || "MRP",
                        OrganizationStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data6 = documentDetails.data) === null || _documentDetails$data6 === void 0 ? void 0 : _documentDetails$data6.OrganizationStateCode,
                        CustomerStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data7 = documentDetails.data) === null || _documentDetails$data7 === void 0 ? void 0 : _documentDetails$data7.CustomerStateCode,
                        IsTaxExempted: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.IsTaxExempted,
                        HSNSACCode: selectedPriceDetails.HSNSACCode,
                        CDMSHSNSACCode: selectedPriceDetails.CDMSHSNSACCode,
                        ChildSystemName: drawerItem.jobType === "Part" ? "Part" : "Labour"
                    };
                    if ((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Part") {
                        // requestBody.HSNCode = drawerItem.HSNCode
                        requestBody.MRP = selectedPriceDetails.MRP;
                        // requestBody.CDMSHSNCode = drawerItem?.CDMSHSNCode
                    }
                    else {
                        // requestBody.SACCode = drawerItem.SACCode
                        // requestBody.CDMSSACCode = drawerItem?.CDMSSACCode
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getTaxUrl,
                            request: requestBody
                        }))];
                case 2:
                    Response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload5 = Response.payload) !== null && _Response$payload5 !== void 0 && (_Response$payload5 = _Response$payload5.value) !== null && _Response$payload5 !== void 0 && _Response$payload5.success && Response !== null && Response !== void 0 && (_Response$payload6 = Response.payload) !== null && _Response$payload6 !== void 0 && (_Response$payload6 = _Response$payload6.value) !== null && _Response$payload6 !== void 0 && _Response$payload6.data) {
                        data = Response === null || Response === void 0 || (_Response$payload7 = Response.payload) === null || _Response$payload7 === void 0 || (_Response$payload7 = _Response$payload7.value) === null || _Response$payload7 === void 0 ? void 0 : _Response$payload7.data;
                        success = true;
                        return [2 /*return*/, {
                                data: data,
                                success: success
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: null,
                                success: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var validateAndGetTax = function (Qty, Rate) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _documentDetailsGetBy4, _documentDetails$data8, _documentDetails$data9, _documentDetails$data10, _installbaseDetailsBy, _Response$payload8, _Response$payload9, requestBody, Response, _Response$payload10, data, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "ProductId": (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.ProductId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.ProductId),
                        "ChildId": drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.ChildId,
                        MRP: selectedPriceDetails.MRP,
                        Quantity: Qty,
                        "Rate": Rate,
                        DocumentDate: documentDetails === null || documentDetails === void 0 || (_documentDetails$data8 = documentDetails.data) === null || _documentDetails$data8 === void 0 ? void 0 : _documentDetails$data8.CreatedOn,
                        "Entity": SystemName,
                        "ServiceTypeId": drawerItem.ServiceTypeId,
                        "UnitOfMeasurementId": drawerItem.UnitOfMeasurementId,
                        "PriceMethod": selectedPriceDetails.PriceGroupCategoryKey || "MRP",
                        OrganizationStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data9 = documentDetails.data) === null || _documentDetails$data9 === void 0 ? void 0 : _documentDetails$data9.OrganizationStateCode,
                        CustomerStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data10 = documentDetails.data) === null || _documentDetails$data10 === void 0 ? void 0 : _documentDetails$data10.CustomerStateCode,
                        IsTaxExempted: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.IsTaxExempted,
                        HSNSACCode: selectedPriceDetails.HSNSACCode,
                        CDMSHSNSACCode: selectedPriceDetails.CDMSHSNSACCode,
                        ChildSystemName: drawerItem.jobType === "Part" ? "Part" : "Labour",
                        DateOfMfg: installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy = installbaseDetailsById.data) === null || _installbaseDetailsBy === void 0 ? void 0 : _installbaseDetailsBy.DateOfMfg
                    };
                    // if (drawerItem?.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem?.HSNCode
                    //     requestBody.CDMSHSNCode = drawerItem?.CDMSHSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem?.SACCode
                    //     requestBody.CDMSSACCode = drawerItem?.CDMSSACCode
                    // }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // if (drawerItem?.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem?.HSNCode
                    //     requestBody.CDMSHSNCode = drawerItem?.CDMSHSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem?.SACCode
                    //     requestBody.CDMSSACCode = drawerItem?.CDMSSACCode
                    // }
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getValidateQuantityAndGetTaxesUrl,
                            request: requestBody
                        }))];
                case 2:
                    Response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload8 = Response.payload) !== null && _Response$payload8 !== void 0 && (_Response$payload8 = _Response$payload8.value) !== null && _Response$payload8 !== void 0 && _Response$payload8.success && Response !== null && Response !== void 0 && (_Response$payload9 = Response.payload) !== null && _Response$payload9 !== void 0 && (_Response$payload9 = _Response$payload9.value) !== null && _Response$payload9 !== void 0 && _Response$payload9.data) {
                        data = Response === null || Response === void 0 || (_Response$payload10 = Response.payload) === null || _Response$payload10 === void 0 || (_Response$payload10 = _Response$payload10.value) === null || _Response$payload10 === void 0 ? void 0 : _Response$payload10.data;
                        success = true;
                        return [2 /*return*/, {
                                data: data,
                                success: success
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: null,
                                success: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var decorateMRPOptionLabel = function (option) {
        if (drawerItem.AutofillType === 2) {
            return 0;
        }
        else {
            if (option.MRP) {
                return "".concat(option.MRP, "  ").concat(option.EffectiveFromDate ? "From: ".concat(option.EffectiveFromDate, ")") : "").concat(option.EffectiveToDate ? " To: ".concat(option.EffectiveToDate) : "");
            }
            else {
                return "";
            }
        }
    };
    return /*#__PURE__*/ React.createElement(Drawer, {
        id: "translate-to-job-drawer-part-labour",
        anchor: IS_MOBILE ? 'bottom' : 'right',
        open: open,
        onClose: function (event, reason) {
            if (reason === "backdropClick") {
                handleClose();
            }
        },
        ModalProps: {
            disableEscapeKeyDown: true,
            onBackdropClick: function (event) { return event.stopPropagation(); }
        },
        sx: {
            display: {
                xs: 'block',
                sm: 'block',
                md: 'block',
                lg: 'block'
            },
            '& .MuiDrawer-paper': {
                width: {
                    xs: '100%',
                    sm: '50%',
                    md: '450px',
                    lg: '450px',
                    xl: '450px'
                },
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px'
            }
        }
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        sx: {
            paddingX: {
                lg: "16px"
            }
        },
        className: "border-bottom-custom"
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            width: '100%',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'xl',
            color: 'text.primary'
        },
        id: "trasnlateToJobItems",
        align: "left"
    }, (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) == "Part" ? "Part details" : "Labour details"), /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "closeIconBtn",
        onClick: handleClose,
        disabled: isLoaderOpen
    }, /*#__PURE__*/ React.createElement(CrossIcon, {
        id: "crossIcon",
        sx: {
            fontSize: 21
        }
    })))), isLoaderOpen || !drawerItem ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null), drawerItem && selectedPriceDetails && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        padding: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        width: '100%'
    }, jobItemType === EJobItemType.PeriodicMaintenance && /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "service-type-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                paddingY: 0,
                paddingLeft: '4px',
                paddingRight: '0px'
            }
        },
        disabled: true,
        checkBoxValue: true
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        spacing: 1.25,
        alignItems: 'center',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-start',
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: (drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType = drawerItem.jobType) === null || _drawerItem$jobType === void 0 ? void 0 : _drawerItem$jobType.substring(0, 1)) == "P" ? "add-new-jobs-part-name" : '"add-new-jobs-labour-name"',
        sx: {
            textTransform: 'capitalize',
            fontWeight: "medium",
            fontSize: 'lg',
            color: 'text.primary'
        }
    }, (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.PartName) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.LabourName) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.ChildName) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Name) || "-")))), /*#__PURE__*/ React.createElement(Chip, {
        label: drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType2 = drawerItem.jobType) === null || _drawerItem$jobType2 === void 0 ? void 0 : _drawerItem$jobType2.substring(0, 1),
        id: drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType3 = drawerItem.jobType) === null || _drawerItem$jobType3 === void 0 ? void 0 : _drawerItem$jobType3.substring(0, 1),
        color: "secondary",
        variant: "filled",
        shape: "circular",
        sx: {
            color: "secondary.900"
        }
    })), /*#__PURE__*/ React.createElement(Typography, {
        id: (drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType4 = drawerItem.jobType) === null || _drawerItem$jobType4 === void 0 ? void 0 : _drawerItem$jobType4.substring(0, 1)) == "P" ? "part-code" : 'labour-code',
        sx: {
            fontSize: 'sm',
            fontWeight: 'mormal',
            color: 'text.secondary'
        },
        marginLeft: jobItemType === EJobItemType.PeriodicMaintenance ? '30px' : '0px'
    }, "#".concat((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.PartCode) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.LabourCode) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.SkuCode) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Code)) || "-"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // },
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, t("Service type")), /*#__PURE__*/ React.createElement(FormSearchSelect, {
        tabIndex: 1,
        id: "serviceType",
        name: "serviceType",
        noOptionsText: "No records found",
        fullWidth: true,
        value: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.ServiceTypeId) || "",
        displayExpr: "DisplayName",
        valueExpr: "id",
        getListData: getServiceTypeList,
        apiKey: 'serviceTypeList',
        disabled: true,
        onChange: handleServiceType
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // }
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, "Rate(\u20B9)"), /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 2,
        placeholder: 'Enter rate',
        fullWidth: true,
        size: "small",
        value: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.Rate) || "",
        name: "rate",
        onChange: function (event) { return handleInputRateChange(event, drawerItem); },
        onBlur: function (e) { return handleTaxesBasedOnRateChange(e); },
        disabled: !(selectedPriceDetails !== null && selectedPriceDetails !== void 0 && selectedPriceDetails.IsRateEditable) || isDisabled
        // error={usageReadingError.error}
        // helperText={t(usageReadingError.errorMessage)}
        ,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        },
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "secondary.50",
                borderRadius: '8px'
            }
        },
        id: "rate"
    }), (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.rateErrorMessage) && /*#__PURE__*/ React.createElement(FormHelperText, {
        sx: {
            color: 'red'
        }
    }, drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.rateErrorMessage)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // }
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Part" ? 'Qty' : 'Unit'), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '36px',
        width: '36px',
        justifyContent: 'center',
        sx: {
            border: "1px solid",
            borderColor: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour" ? 'secondary.200' : 'info.500',
            borderRadius: 0,
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () {
            handleQuantityDecrement();
        },
        size: "small",
        id: "decrement-btn",
        disabled: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour" || drawerItem.IsAutoFill
    }, /*#__PURE__*/ React.createElement(GridRemoveIcon, {
        sx: {
            color: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour" || drawerItem.IsAutoFill ? "secondary.200" : 'primary.500'
        }
    }))), /*#__PURE__*/ React.createElement(TextField, {
        value: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Quantity,
        variant: "outlined",
        size: "small",
        id: "unit-input",
        inputProps: {
            style: {
                textAlign: 'center',
                height: '26px',
                padding: 0
            }
        },
        InputProps: {
            sx: {
                background: '#e6f2ff'
            }
        },
        sx: {
            borderTop: "1px solid",
            borderBottom: "1px solid",
            borderColor: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour" || drawerItem.IsAutoFill ? 'secondary.200' : 'info.500',
            '& fieldset': {
                border: 'none'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: 0
            },
            '& .MuiInputBase-root': {
                height: '100%'
            }
        },
        onChange: function (event) {
            handleQuantityChange(event);
        },
        onBlur: handleOnBlurQuantityChange,
        error: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.error,
        disabled: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour",
        type: "number"
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        height: '36px',
        width: '36px',
        justifyContent: 'center',
        sx: {
            border: "1px solid",
            borderRadius: 0,
            borderColor: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour" || drawerItem.IsAutoFill ? 'secondary.200' : 'info.500',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () {
            handleQuantityIncrement();
        },
        size: "small",
        disabled: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour",
        id: "increment-btn"
    }, /*#__PURE__*/ React.createElement(GridAddIcon, {
        sx: {
            color: isDisabled || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) === "Labour" || drawerItem.IsAutoFill ? "secondary.200" : 'primary.500'
        }
    })))), (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.errorMessage) && /*#__PURE__*/ React.createElement(FormHelperText, {
        sx: {
            color: 'red'
        }
    }, drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.errorMessage)), (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) == "Part" ? /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) == "Part" ? 6 : 12,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // },
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, "UOM"), /*#__PURE__*/ React.createElement(FormSearchSelect, {
        id: "select-uom",
        name: "UOM",
        noOptionsText: "No records found",
        fullWidth: true,
        value: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.UnitOfMeasurementId) || "",
        displayExpr: "Name",
        valueExpr: "id",
        getListData: UnitOfMeasurementList,
        apiKey: 'UnitOfMeasurementList',
        disabled: true,
        tabIndex: 3,
        onChange: handleChangeUOM
    })) : null, (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.jobType) == "Part" && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // },
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, "M.R.P.(\u20B9)"), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 4,
        caption: t('MRP_SELECT_PLACEHOLDER'),
        margin: 0,
        fullWidth: true,
        name: "mrp",
        value: (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.MRP) || "",
        displayExpr: "MRP",
        valueExpr: "MRP",
        onChange: handleChangePrice,
        options: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Price) || [],
        id: "select-mrp",
        disabled: !(selectedPriceDetails && (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.PriceGroupCategoryKey) === "MRP") || isDisabled || (drawerItem === null || drawerItem === void 0 || (_drawerItem$Price = drawerItem.Price) === null || _drawerItem$Price === void 0 ? void 0 : _drawerItem$Price.length) === 1,
        getOptionLabel: function (option) {
            return decorateMRPOptionLabel(option);
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "Amount"), /*#__PURE__*/ React.createElement(Typography, {
        id: "total-amount",
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.Amount) || 0).toFixed(2))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'end'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        onClick: function () {
            if (openSummary) {
                setOpenTaxes(false);
            }
            setOpenSummary(!openSummary);
        },
        variant: "text",
        endIcon: openSummary ? /*#__PURE__*/ React.createElement(ChevronUpIcon, null) : /*#__PURE__*/ React.createElement(ChevronDownIcon, null),
        name: "See summary",
        sx: {
            backgroundColor: 'transparent',
            pr: 0,
            fontWeight: "medium",
            fontSize: 'sm'
        },
        id: "add-again"
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(Collapse, {
        in: openSummary,
        sx: {
            borderRadius: '8px',
            boxShadow: '0px 0px 16px 0px #00000014'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: '12px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        sx: {
            mt: 0
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        }
    }, "Base amount")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "base-amount",
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.BaseAmount) || 0).toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        }
    }, "Taxable amount")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "taxable-amount",
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.TaxableAmount) || 0).toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            cursor: "pointer",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, "Taxes"), /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        id: "taxes-btn-icon",
        onClick: function () { return setOpenTaxes(!openTaxes); },
        sx: {
            p: 0.5
        }
    }, openTaxes ? /*#__PURE__*/ React.createElement(ExpandLess, {
        sx: {
            fontSize: 25
        }
    }) : /*#__PURE__*/ React.createElement(ExpandMore, {
        sx: {
            fontSize: 25
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "total-tax",
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ", (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : totalTax))), openTaxes && /*#__PURE__*/ React.createElement(Collapse, {
        in: openTaxes,
        sx: {
            bgcolor: "secondary.50",
            p: 2,
            borderRadius: 2
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, selectedPriceDetails && (selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails2 = selectedPriceDetails.Taxes) === null || _selectedPriceDetails2 === void 0 ? void 0 : _selectedPriceDetails2.length) > 0 ? selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails3 = selectedPriceDetails.Taxes) === null || _selectedPriceDetails3 === void 0 ? void 0 : _selectedPriceDetails3.map(function (tax, index) {
        var _selectedPriceDetails4;
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontWeight: "medium",
                fontSize: 'sm',
                color: 'text.tertiary'
            },
            id: "tax-component-name"
        }, tax === null || tax === void 0 ? void 0 : tax.TaxComponentName, " :")), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            sx: {
                display: 'flex',
                justifyContent: 'end'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "tax-component-percentage",
            sx: {
                fontWeight: "medium",
                fontSize: 'base',
                color: 'text.secondary'
            }
        }, "".concat((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : (tax === null || tax === void 0 ? void 0 : tax.TaxComponentPercentage) || 0, " %")), /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                mx: 1.5,
                my: 0.5,
                bgcolor: 'secondary.50'
            },
            orientation: "vertical",
            flexItem: true
        }), /*#__PURE__*/ React.createElement(Typography, {
            id: "tax-component-amount",
            sx: {
                fontWeight: "medium",
                fontSize: 'base',
                color: 'text.primary'
            }
        }, "\u20B9 ", parseFloat((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.AutofillType) === 2 ? 0 : (tax === null || tax === void 0 ? void 0 : tax.TaxComponentAmount) || 0).toFixed(2))), (selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails4 = selectedPriceDetails.Taxes) === null || _selectedPriceDetails4 === void 0 ? void 0 : _selectedPriceDetails4.length) - 1 != index && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            py: 0.5,
            mt: 0.5
        }, /*#__PURE__*/ React.createElement(Divider, {
            style: {
                width: '100%',
                borderTop: '1.5px dashed #DEE4EB',
                borderBottom: 'none',
                borderLeft: 'none',
                borderRight: 'none'
            }
        })));
    }) : /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1
    }, /*#__PURE__*/ React.createElement(Typography, null, t("No data found")))))))))), /*#__PURE__*/ React.createElement(Backdrop, {
        sx: function (theme) { return ({
            color: 'white',
            zIndex: theme.zIndex.drawer + 1
        }); },
        open: isLoaderOpen
        // onClick={handleClose}
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        color: "inherit"
    })));
};
export default PartLabourDetailsDrawer;
